<template>
  <ul class="button-container_list space-between">
    <li
      class="button-container_list_item modal-list"
      v-for="(option, index) in array"
      :key="option.id"
    >
      <input
        type="radio"
        :id="keyName + '_0' + index"
        :name="keyName"
        :value="option.value"
        :checked="option.value === selectValue"
        class="item-input"
        @change="$emit('change', $event.target.value)"
      />
      <label
      class="item-label width100per u-p10"
      :for="keyName + '_0' + index">
        {{ option.label }}
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    keyName: {
      type: String,
      required: true,
    },
    array: {
      type: Array,
      required: true,
    },
    // radioWidth: {
    //   type: String,
    //   required: false,
    // },
    selectValue: {
      type: String,
      required: true,
    }
  }
}
</script>

<style src="../../pages/attendance/list/main.scss" lang="scss" scoped></style>



